import {
  currentFundingReasonFormNameRoutine,
  currentFundingReasonFormVersionRoutine,
  fundingAmountRoutine,
  CURRENT_FORM_NAME_CLEANUP,
  FUNDING_AMOUNT_CLEANUP
} from '@/store/modules/currentFormDetails/routines'

export default {
  [currentFundingReasonFormNameRoutine.TRIGGER](state, payload) {
    state.currentFundingReasonFormName = payload
  },
  [currentFundingReasonFormVersionRoutine.TRIGGER](state, payload) {
    state.currentFundingReasonFormVersion = payload
  },
  [fundingAmountRoutine.TRIGGER](state, payload) {
    state.fundingAmount = payload
  },
  [CURRENT_FORM_NAME_CLEANUP](state, payload) {
    Object.assign(state, payload)
  },
  [FUNDING_AMOUNT_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
